import { defineComponent as u, ref as c, watch as d, createBlock as m, openBlock as a, mergeProps as p, unref as n, createSlots as y, withCtx as i, createElementBlock as v, renderSlot as s, Fragment as B, createTextVNode as g, toDisplayString as h } from "vue";
import k from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Button/button.js";
import N from "./Button.vue2.js";
import { useOUIAProps as S } from "../helpers/ouia.js";
const C = /* @__PURE__ */ u({
  name: "PfNotificationBadge",
  __name: "NotificationBadge",
  props: {
    variant: { default: "read" },
    count: { default: 0 },
    expanded: { type: Boolean },
    shouldNotify: { type: Boolean }
  },
  setup(r) {
    const o = r, f = S({ id: o.ouiaId, safe: o.ouiaSafe }), t = c(!1);
    d(() => o.shouldNotify, (e) => {
      e && (t.value = !0);
    });
    function l() {
      t.value = !1;
    }
    return (e, P) => (a(), m(N, p(n(f), {
      variant: "stateful",
      state: e.variant,
      class: { [n(k).modifiers.notify]: t.value },
      onAnimationend: l
    }), y({
      default: i(() => [
        e.count > 0 ? (a(), v(B, { key: 0 }, [
          g(h(e.count), 1)
        ], 64)) : s(e.$slots, "default", { key: 1 })
      ]),
      _: 2
    }, [
      e.$slots.icon ? {
        name: "icon",
        fn: i(() => [
          s(e.$slots, "icon")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["state", "class"]));
  }
});
export {
  C as default
};
